import React, { useEffect } from 'react';
import GeophoneAddPhoto from '../images/GeophoneAdd.png';
import GeophoneEditPhoto from '../images/GeophoneEdit.png';
import GeophoneRemoveOnePhoto from '../images/GeophoneRemoveOne.png';
import GeophoneRemoveAllPhoto from '../images/GeophoneRemoveAll.png';
import styled from 'styled-components';

const StyledContainer = styled.div`
width: 100%;
margin: auto;
padding: 10px 0px 10px 0px;
`;

const GeophonePage = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ fontSize: "18px" }}>
        <div style={{ fontSize: "32px", fontWeight: "bold", marginTop: '10px'}}>
        Geophone
        </div>
        <div style={{ margin: '10px 0px' }}>
        To add Geophone, right click <strong>Wellbore</strong> node which you want add Geophone to, then click <strong>Add Geophone</strong> menu. In <strong>Add Geophone</strong> dialog, 
        enter Name, Color, Radius, Height and Positions, then click <strong>OK</strong>.
        </div>
        <div style={{ margin: '10px 0px' }}>
        Positions' data format is Measure Depth. Each Geophone is in a line. 
        </div>

        <StyledContainer>
            <img src={GeophoneAddPhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>

        <div style={{ margin: '10px 0px' }}>
        To edit Geophone, right click Geophone node you want to edit, then click <strong>Edit This Geophone</strong> menu.
        </div>

        <StyledContainer>
            <img src={GeophoneEditPhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>

        <div style={{ margin: '10px 0px' }}>
        To remove Geophone, right click Geophone node you want to remove, then click <strong>Remove This Geophone</strong> menu.
        </div>
        <StyledContainer>
            <img src={GeophoneRemoveOnePhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>

        <div style={{ margin: '10px 0px' }}>
        To remove all of Geophones, right click <strong>Geophones</strong> node, then click <strong>Remove All Geophones</strong> menu.
        </div>
        <StyledContainer>
            <img src={GeophoneRemoveAllPhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>
    </div>
  )
}

export default GeophonePage;